export default __webpack_public_path__ + "static/media/Background.6abd7bc5.png";